import React from 'react';
import planetsData from '../spacecast/config/PlanetsData';
import nearStarsData from '../spacecast/config/NearStarsData';
import grey from '@material-ui/core/colors/grey';
import {
  Modal,
  Box,
  Container,
  Paper,
  Typography,
  IconButton,
  Grid,
  Select,
  MenuItem,
  ListSubheader,
  Button,
} from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';

export default function TargetModal({
  isOpen,
  close,
  setShowInfo,
  setShowStopButton,
  targetName,
  setTargetName,
}) {

  const handleChange = e => {
    if (e.target.value) {
      setTargetName(e.target.value);
    }
  }

  const handleGo = () => {
    let destination = getDestination();

    if (destination) {
      setShowInfo(true);
      setShowStopButton(true);
      window.spacecast.controls.travelTo(destination, () => {
        setShowStopButton(false);
        setTimeout(() => setShowInfo(false), 4000);
      });
    }

    close();
  }

  const getDestination = () => {
    if (!targetName) {
      return null;
    }

    let destination = null;

    const valueArray = targetName.split('|');
    if (valueArray.length === 1 && valueArray[0] === 'spacecast') {
      destination = window.spacecast.getBeam();
    }
    if (valueArray.length === 1 && valueArray[0] === 'Sun') {
      destination = window.spacecast.getSun();
    }
    else if (valueArray.length === 2) {
      const type = valueArray[0];
      const name = valueArray[1];
      if (type === 'planet') {
        destination = window.spacecast.getPlanets().find(planet => (planet.name === name));
      }
      else if (type === 'star') {
        destination = window.spacecast.getNearStars().find(star => (star.name === name));
      }
    }

    return destination;
  }

  return (
    <Box>
      <Modal open={isOpen}>
        <Box display="flex" alignItems="center" justifyContent="center" style={{width:'100dvw', height:'100dvh'}}>
          <Container style={{outline:'none'}} maxWidth="xs">
            <Paper style={{padding:'16px 24px', backgroundColor:grey[300]}}>
              <Box display="flex">
                <Box flex="1" display="flex" alignItems="center">
                  <Typography variant="h5">Navigate to</Typography>
                </Box>
                <Box>
                <IconButton onClick={close}>
                  <CloseIcon />
                </IconButton>
                </Box>
              </Box>
              <Grid container spacing={3} style={{marginTop:8}}>
                <Grid item xs={12} sm={6}>
                  <Select value={targetName ?? "spacecast"} onChange={handleChange} style={{width:'100%'}}>
                    <MenuItem value="spacecast">
                      <em>Spacecast</em>
                    </MenuItem>

                    <ListSubheader>Planets</ListSubheader>
                    {Object.keys(planetsData).map(planetName => <MenuItem key={planetName} value={`planet|${planetName}`}>{planetName}</MenuItem>)}

                    <ListSubheader>Stars</ListSubheader>
                    <MenuItem value="Sun">Sun</MenuItem>
                    {nearStarsData.map(nearStar => <MenuItem key={nearStar.name} value={`star|${nearStar.name}`}>{nearStar.name}</MenuItem>)}
                  </Select>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box>
                    <Button
                      variant="contained"
                      color="default"
                      onClick={handleGo}
                    >
                      Go
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Container>
        </Box>
      </Modal>
    </Box>
  );
}